import { tns } from '../../node_modules/tiny-slider/src/tiny-slider';

(function () {
  if (!document.body.classList.contains('single-product')) return this;

  const gallery_slider = tns({
    autoHeight: 'auto',
    container: '.product-gallery__slider',
    navContainer: '.flex-control-thumbs',
    controlsText: ['<span class="prev"></span>','<span class="next"></span>'],
    controlsPosition: 'bottom',
    mouseDrag: true,
    swipeAngle: false,
    controls: false,
    items: 1,
    lazyload: true,
    lazyloadSelector: 'img',
    loop: true,
    navAsThumbnails: true,
  });

  document.querySelector('.tns-inner').onclick = function () {
    gallery_slider.goTo('next');
  };
})();
